import type { JsonLdNode } from '../jsonld/types'

/** `<` is escaped so a `</script>` inside merchant copy can't close the tag. */
export const serializeJsonLd = (node: JsonLdNode): string =>
  JSON.stringify(node).replace(/</g, '\\u003c')

/**
 * Renders schema.org nodes as `application/ld+json`. Server component — the
 * markup is in the initial HTML for crawlers that don't run JavaScript.
 */
export const JsonLd = ({ data }: { data: (JsonLdNode | undefined)[] | JsonLdNode | undefined }) => {
  const nodes = (Array.isArray(data) ? data : [data]).filter((node): node is JsonLdNode =>
    Boolean(node)
  )

  return (
    <>
      {nodes.map((node, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: serializeJsonLd(node) }}
        />
      ))}
    </>
  )
}
